// global imports
require('../assets/shared');
require('../assets/shared_functions');
require('../site_scripts/mtc_lazy_load_images');

// modules
require('../site_scripts/mtc_youtube_overlay');
require('../global/read-more');
require('../omoda/modules/counter-increment');
require('../site_scripts/mtc_lazy_load_recaptcha_form')
require('../site_scripts/mtc_simple_form_submit')

require('../../../../core/js/plugins/mtc_slick');

// omoda page styles
require('../../styles/entry/omoda.less');



jQuery(function ($){
    
    $('.gridSection:not(.gridSection__2cols) .gridSection__container').slick({
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        responsive: [
            {
                breakpoint: 960,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 670,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    

    $('.fullPageBanner').slick({
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev"><img src="/sites/petervardy/images/slider-left.png" alt="Previous"></button>',
        nextArrow: '<button type="button" class="next"><img src="/sites/petervardy/images/slider-right.png" alt="Next"></button>',
        arrows: true,
    });

    let lastScrollTop = 0;
    window.addEventListener('scroll', function() {
        const headerContainer = document.querySelector('.omodaRegisterInterestStickyHeader');

        if (headerContainer) {
            const scrollTop = window.scrollY || document.documentElement.scrollTop;

            if (scrollTop > lastScrollTop && scrollTop > 335) {
                headerContainer.classList.add('omodaRegisterInterestStickyHeader--isVisible');
            } else {
                headerContainer.classList.remove('omodaRegisterInterestStickyHeader--isVisible');
            }

            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

        }

    });

    const omodaRegisterInterestStickyHeaderButton = document.querySelector('.omodaRegisterInterestStickyHeader__button')

    if (omodaRegisterInterestStickyHeaderButton) {
        omodaRegisterInterestStickyHeaderButton.addEventListener('click', (e) => {
            e.preventDefault()

            const hash = e.target.hash

            if (hash) {
                const form = document.querySelector(hash)

                window.scrollTo({
                    top: form.offsetTop,
                    left: 0,
                    behavior: 'smooth'
                })
            }
        })
    }
});
